(() => {
  'use strict';

  const selector='video[data-product-video]';
  const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      const video=entry.target;
      if(entry.isIntersecting&&!document.hidden&&!reduceMotion){
        video.muted=true;
        video.play().catch(()=>{});
      }else{
        video.pause();
      }
    });
  },{rootMargin:'180px 0px',threshold:.08}):null;

  function enhance(root=document){
    root.querySelectorAll(`${selector}:not([data-video-ready])`).forEach(video=>{
      video.dataset.videoReady='true';
      video.muted=true;
      video.defaultMuted=true;
      if(observer)observer.observe(video);
      else if(!reduceMotion)video.play().catch(()=>{});
    });
  }

  enhance();
  new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{
    if(node.nodeType!==1)return;
    if(node.matches?.(selector))enhance(node.parentElement||document);
    else enhance(node);
  }))).observe(document.body,{childList:true,subtree:true});

  document.addEventListener('visibilitychange',()=>{
    document.querySelectorAll(selector).forEach(video=>{
      if(document.hidden)video.pause();
      else if(!reduceMotion&&video.getBoundingClientRect().bottom>-180&&video.getBoundingClientRect().top<innerHeight+180)video.play().catch(()=>{});
    });
  });
})();
